import { Divider, Stack } from '@mui/material';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import { AccordionSection } from './AccordionSection';
import { ToggleSwitch } from './ToggleSwitch';
import { useFlightsFilters } from 'frontend/contexts/FlightsFiltersContext';
import { useCallback } from 'react';

const scaleOptions = [
  { id: 'oneStop', label: '1 Escala', value: '1 Escala' },
  { id: 'multiStop', label: '2 o más escalas', value: '2 o más escalas' },
]

export const FlightsFilterByScale = ({
  dropdownState,
  toggleDropdown,
  handleDirectChange,
  handleScaleChange,
  background,
}) => {
  const { handleFilters, filters } = useFlightsFilters();

  const handleAllScalesChange = useCallback(() => {
    if (filters.direct) {
      handleFilters('direct', false);
    }

    const newScale =
      filters.scales === 'Todas las escalas' ? 'Todas las escalas' : 'Todas las escalas';

    handleFilters('scales', newScale);
  }, [filters.direct, filters.scales]);

  const handleScaleOption = useCallback((value) => {
    if (filters.direct) {
      handleFilters('direct', false);
    }
    handleScaleChange(value);
  }, [filters.direct, handleScaleChange]);

  return (
    <Stack gap={2}>
      <AccordionSection
        title="Vuelos"
        isOpen={dropdownState.flights}
        onToggle={() => toggleDropdown('flights')}
      >
        <Stack spacing={2}>
          <ToggleSwitch
            isActive={filters.scales === 'Todas las escalas' && !filters.direct}
            onChange={handleAllScalesChange}
            label="Todas"
            icon={AirplaneTicketIcon}
            background={background}
          />

          <ToggleSwitch
            isActive={filters.direct}
            onChange={handleDirectChange}
            label="Vuelo directo"
            icon={LocalAirportIcon}
            background={background}
          />

          {scaleOptions.map((option) => (
            <ToggleSwitch
              key={option.id}
              isActive={filters.scales === option.value}
              onChange={() => handleScaleOption(option.value)}
              label={option.label}
              icon={ConnectingAirportsIcon}
              background={background}
            />
          ))}
        </Stack>
      </AccordionSection>
      <Divider />
    </Stack>
  );
};
